import { ReactNode } from "react";
import { Box } from "@mui/material";
import {
    UNDERLYING_LIST_COLUMN_GAP_PX,
    UnderlyingListOverlayPlacement,
} from "src/components-mui/modules/underlying-lists-module/underlying-lists-module.constants";

const STACKED_IN_SAME_CELL_SX = { gridArea: "1 / 1" } as const;

const OVERLAY_PLACEMENT_SX = {
    [UnderlyingListOverlayPlacement.SpanningColumns]: {
        position: { md: "absolute" },
        top: { md: "50%" },
        left: { md: `calc(100% + ${UNDERLYING_LIST_COLUMN_GAP_PX / 2}px)` },
        transform: { md: "translate(-50%, -50%)" },
    },
    [UnderlyingListOverlayPlacement.CompactOnly]: {
        display: { md: "none" },
    },
} as const satisfies Record<UnderlyingListOverlayPlacement, object>;

interface IListLockedRowsProps {
    overlay: ReactNode;
    overlayPlacement: UnderlyingListOverlayPlacement;
    children: ReactNode;
}

export const ListLockedRows = ({ overlay, overlayPlacement, children }: IListLockedRowsProps) => (
    <Box sx={{ position: "relative", display: "grid", gridTemplateColumns: "minmax(0, 1fr)" }}>
        <Box sx={STACKED_IN_SAME_CELL_SX} aria-hidden>
            {children}
        </Box>
        <Box sx={{ ...STACKED_IN_SAME_CELL_SX, backdropFilter: "blur(8px)" }} />
        <Box
            sx={{
                ...STACKED_IN_SAME_CELL_SX,
                zIndex: 1,
                alignSelf: { xs: "start", sm: "center" },
                mt: { xs: 3, sm: 0 },
                ...OVERLAY_PLACEMENT_SX[overlayPlacement],
            }}
        >
            {overlay}
        </Box>
    </Box>
);
